// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_15-1";
export var movingGradient = "_15-4";
export var movingGradientBlock = "_15-2";
export var skeleton = "_15-0";
export var skeletonText = "_15-3";